export const enAccessDenied = {
  'accessDenied.title': 'Access Denied',
  'accessDenied.description1':
    'You currently don’t have permission to access this application. \nTo proceed, you need valid access rights and an assigned role.',
  'accessDenied.description2':
    'Please contact your administrator or follow your internal request process to gain access.',
  'accessDenied.footer.description': 'Supported by',
};
